import { FilePicker } from '@robingenz/capacitor-file-picker'
export type { File as PickFile } from '@robingenz/capacitor-file-picker'
import { captureError } from '@/core/errors'

/**
 * @description
 * pc/ios/androidのファイルシステムからファイル取得する
 *
 * @returns base64 string
 */
export const pickFile = async (types: string[]) => {
  const res = await FilePicker.pickFiles({
    types,
    multiple: false,
  }).catch(e => {
    if (e.message === 'pickFiles canceled.')
      throw new Error('キャンセルしました。もう一度お試しください。')

    if (e?.currentTarget?.error?.name === 'NotReadableError')
      throw new Error('notReadableError')

    captureError(e, 'pickFile')

    throw e
  })

  return res.files[0]
}
